import { getFormatInfoGivenType, molFormatInformation, } from "./LoadSaveMolModels/Types/MolFormats";
import { getFileType } from "./FileUtils2";
/**
 * Class FileInfo
 */
export class FileInfo {
    name;
    contents;
    compressedName;
    treeNode;
    cachedConvertText = {};
    auxData;
    /**
     * The constructor.
     *
     * @param {IFileInfo} fileInfo  The IFileInfo object.
     */
    constructor(fileInfo) {
        this.name = fileInfo.name;
        this.contents = fileInfo.contents;
        this.compressedName = fileInfo.compressedName;
        this.treeNode = fileInfo.treeNode;
    }
    /**
     * Serializes this FileInfo object.
     *
     * @returns {IFileInfo}  The serialized object.
     */
    serialize() {
        return {
            name: this.name,
            contents: this.contents,
            compressedName: this.compressedName,
            treeNode: this.treeNode,
            auxData: this.auxData,
        };
    }
    /**
     * Returns the file type.
     *
     * @returns {string | undefined}  The file type.
     */
    getFileType() {
        return getFileType(this);
    }
    /**
     * Returns the format info.
     *
     * @returns {IFormatInfo | undefined}  The format info.
     */
    getFormatInfo() {
        const typ = this.getFileType();
        if (typ === undefined)
            return;
        return getFormatInfoGivenType(typ);
    }
    /**
     * Assigns the extension based on the contents. Guesses the format.
     */
    assignExtByContents() {
        const format = this.guessFormat();
        if (format) {
            this.name = this.name + "." + format.primaryExt;
        }
    }
    /**
     * Guesses the format.
     *
     * @returns {IFormatInfo | undefined}  The format info.
     */
    guessFormat() {
        const contents = this.contents.trim();
        for (const formatID in molFormatInformation) {
            const format = molFormatInformation[formatID];
            if (format.validateContents === undefined) {
                // No way of validating this one.
                continue;
            }
            if (format === molFormatInformation.SMI) {
                // Waiting until the end to do SMI (it's the most permissive)
                continue;
            }
            if (format.validateContents(contents)) {
                return format;
            }
        }
        // Now try SMI
        if (molFormatInformation.SMI.validateContents &&
            molFormatInformation.SMI.validateContents(contents)) {
            return molFormatInformation.SMI;
        }
        // Return undefined if format not found.
        return;
    }
}
